<template>
  <div class="querypage">
    <div class="queryname">
      <div>
        <span class="font26">{{userinfo.Name}}</span>
        <span>{{userinfo.CardNumber}}</span>
        <span class="cor" @click="switchPerson">切换就诊人</span>
        <span class="needle">></span>
      </div>
    </div>
    <div class="paytime">
      <span>就诊时间：</span>
      <span class="sel" @click="checkPickerOption">{{timeType}}</span>
    </div>
    <div class="querytype">
      <span :class="{checkdefult:currentCheck=='lab'}" @click="selectMenu('lab')">检验结果</span>
      <span :class="{checkdefult:currentCheck=='exam'}" @click="selectMenu('exam')">检查报告</span>
      <span :class="{checkdefult:currentCheck=='evaluation'}" @click="selectMenu('evaluation')">评定报告</span>
      <!--<span :class="checkdefult:currentCheck==''">中医报告</span>-->
    </div>
    <div class="typename" v-for="item in presentation" v-show="isShow">
      <div class="posrelative" @click="goToPage(item.Type,item.CheckID)">
        <div>
          <img src="../../assets/images/report.png" alt class="reportpic">
        </div>
        <div>
          <p class="checkname">{{item.Name}}</p>
          <p class="checktime">{{item.Time}}</p>
        </div>
        <span class="point">></span>
      </div>
    </div>

    <div class="noDate" v-show="!isShow">
      <div v-show="true" class="nolist">
        <!-- 无数据显示 -->
        <img src="../../assets/images/searchbg.png" alt class="searchpic">
        <p class="center">暂无数据</p>
      </div>
    </div>
  </div>
</template>

<script>
import { GetPresentationAll } from "@/services/getData.js";
import weui from "weui.js";
export default {
  name: "query-page",
  created: function() {
    this.userinfo = this.$store.state.userInfo;
    this.getPresentationAll(0);
  },
  data() {
    return {
      timeType: "七天内",
      userinfo: {},
      currentCheck: "lab",
      presentationList: {},
      presentation: {},
      isShow: true
    };
  },
  methods: {
    checkPickerOption: function() {
      var _that = this;
      weui.picker(
        [
          {
            label: "七天内",
            value: 0
          },
          {
            label: "三个月内",
            value: 1
          },
          {
            label: "半年内",
            value: 2
          },
          {
            label: "不限时间",
            value: 3
          }
        ],
        {
          onChange: function(result) {
            // console.log(result);
          },
          onConfirm: function(result) {
            _that.timeType = result["0"]["label"];
            _that.getPresentationAll(result["0"]["value"]);
          }
        }
      );
    },
    goToPage(type, checkID) {
      switch (type) {
        case 2:
          this.seeResultFun(checkID);
          break;
        case 1:
          this.checkReportFun(checkID);
          break;
        case 5:
          this.evaluationFun(checkID);
          break;
        default:
          break;
      }
    },
    seeResultFun(checkID) {
      //   跳转到检验结果页
      this.$router.push({
        path: "/report/result",
        query: { checkID: checkID }
      });
    },
    checkReportFun(checkID) {
      //   跳转到检查报告页
      this.$router.push({
        path: "/report/checkreport",
        query: { checkID: checkID }
      });
    },
    evaluationFun(checkID) {
      //   跳转到评定报告页
      this.$router.push({
        path: "/report/evaluationreport",
        query: { checkID: checkID }
      });
    },
    switchPerson() {
      //跳转到切换就诊人页
      this.$router.push({ path: "/card/switchcard" });
    },
    selectMenu(state) {
      this.currentCheck = state;
      switch (state) {
        case "lab":
          this.presentation = _.filter(this.presentationList, function(item) {
            return item.Type == 2;
          });
          if (this.presentation.length > 0) {
            this.isShow = true;
          } else {
            this.isShow = false;
          }
          break;
        case "exam":
          this.presentation = _.filter(this.presentationList, function(item) {
            return item.Type == 1;
          });
          if (this.presentation.length > 0) {
            this.isShow = true;
          } else {
            this.isShow = false;
          }
          break;
        case "evaluation":
          this.presentation = _.filter(this.presentationList, function(item) {
            return item.Type == 5;
          });
          if (this.presentation.length > 0) {
            this.isShow = true;
          } else {
            this.isShow = false;
          }
          break;
      }
    },
    getPresentationAll(timeType) {
      var loading = weui.loading("loading", {
        className: "custom-classname",
        content: "加载中"
      });
      GetPresentationAll(timeType).then(response => {
        loading.hide();
        this.presentationList = response.data;
        this.selectMenu("lab");
      });
    }
  }
};
</script>
<style>
.querypage {
  width: 100%;
  height: 100%;
}

.querypage .queryname {
  width: 100%;
  height: 0.8rem;
  background: rgba(21, 146, 228, 1);
  padding: 0 0.2rem;
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 0.8rem;
  box-sizing: border-box;
}

.queryname > div {
  position: relative;
}

.querypage .queryname .cor {
  color: #feff82 !important;
  float: right;
  margin-right: 0.4rem;
}

.querypage .queryname .needle {
  font-size: 0.31rem;
  font-family: MicrosoftYaHei;
  position: absolute;
  right: 0;
  top: -0.02rem;
}

.querypage .queryname .font26 {
  font-size: 0.26rem !important;
}

.querypage .queryname .font22 {
  font-size: 0.22rem !important;
}

select {
  outline: none;
  border: 0;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.2rem;
  width: auto;
  padding: 0 0.3rem;
}

.querypage .paytime {
  padding: 0.2rem;
  height: auto;
  font-size: 0.22rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}

.querypage .querytype {
  background-color: white;
  width: 100%;
  display: flex;
  height: 0.8rem;
  text-align: center;
  line-height: 0.8rem;
  font-size: 0.24rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  flex-direction: row;
  margin-bottom: 0.2rem;
}

.querypage .querytype > span {
  flex: 1;
}

.querypage .querytype > span:nth-child(2) {
  border-left: 0.01rem solid #dddddd;
  border-right: 0.01rem solid #dddddd;
}

.querypage .querytype > span:last-child {
  border-left: 0.01rem solid #dddddd;
}

.querypage .querytype .checkdefult {
  color: rgba(21, 146, 228, 1) !important;
  border-bottom: 0.04rem solid #1592e4;
}

.querypage .typename {
  width: 100%;
  height: 1.2rem;
  padding: 0 0.2rem;
  background-color: white;
  box-sizing: border-box;
  padding-top: 0.28rem;
  margin-bottom: 0.2rem;
}

.querypage .typename .reportpic {
  width: 0.51rem;
  height: 0.57rem;
  margin-right: 0.3rem;
}

.querypage .typename .checkname {
  font-size: 0.26rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 0.32rem;
}

.querypage .typename .checktime {
  font-size: 0.2rem;
  font-family: MicrosoftYaHei;
  font-weight: 400;
  color: #999999;
  line-height: 0.32rem;
}

.querypage .typename .posrelative {
  position: relative;
}

.querypage .typename .posrelative > div {
  display: inline-block;
}

.querypage .typename .posrelative .point {
  font-size: 0.31rem;
  font-family: MicrosoftYaHei;
  position: absolute;
  right: 0;
  top: 0.1rem;
}

.querypage .sel {
  width: 1.5rem;
  height: 0.4rem;
  background: rgba(255, 255, 255, 1);
  border-radius: 0.2rem;
  line-height: 0.4rem;
  /* text-align: center; */
  display: inline-block;
  position: relative;
  box-sizing: border-box;
  padding-left: 0.2rem;
}

.querypage .sel::after {
  position: absolute;
  display: inline-block;
  content: "";
  right: 0.18rem;
  width: 0;
  height: 0rem;
  border-width: 0.11rem 0.07rem;
  border-style: solid;
  border-color: #333333 transparent transparent transparent;
  font-size: 0.18rem;
  color: #fefefe;
  top: 0.15rem;
}
</style>



// WEBPACK FOOTER //
// src/components/reportquery/query-home.vue